import generalController from "../controllers/generalController";

// Return endpoint url.
export function getEndpointUrl(name) {
  // Get the current env
  const env = generalController.detectEnvironment()
  const langCode = generalController.detectLanguage()
  const province = generalController.getMetatagValue('province');
  // Get a mazda drupal API url.
  const mzDrupalAPI = process.env.REACT_APP_MAZDA_DRUPAL_API || '';

  const endpointsList = {
    dev: {
      // CPO APIs
      'contact-dealer': 'https://devcpo.mazda.ca/API/ContactDealerservice/submit',
      'kmi': 'https://devcpo.mazda.ca/API/keepmeinformed/submit',
      'request-quote': 'https://devcpo.mazda.ca/API/requestaquote/submit',
      'test-drive': 'https://devcpo.mazda.ca/API/bookatestdrive/submit',
      'contact': "https://devcpo.mazda.ca/API/contactus/submit",
      'service-appt': "https://devcpo.mazda.ca/API/BookService/Submit",
      'geolocation': "https://devcpo.mazda.ca/api/geocode/json",
      'cbb': `https://devcpo.mazda.ca/API/CanBlackBook/submit`,
      // Mazda Drupal API
      'model-years': `${mzDrupalAPI}/api/ModelYears?lang_code=${langCode}&prov_code=${province}`,
      'model-search': `${mzDrupalAPI}/api/Model`,
      'find-dealers': `${mzDrupalAPI}/api/Dealers?lang_code=${langCode}&limit=50`,
    },
    stage: {
      // CPO APIs
      'contact-dealer': 'https://stagingcpo.mazda.ca/API/ContactDealerservice/submit',
      'kmi': 'https://stagingcpo.mazda.ca/API/keepmeinformed/submit',
      'request-quote': 'https://stagingcpo.mazda.ca/API/requestaquote/submit',
      'test-drive': 'https://stagingcpo.mazda.ca/API/bookatestdrive/submit',
      'contact': "https://stagingcpo.mazda.ca/API/contactus/submit",
      'service-appt': "https://stagingcpo.mazda.ca/API/BookService/Submit",
      'geolocation': "https://stagingcpo.mazda.ca/api/geocode/json",
      'cbb': `https://stagingcpo.mazda.ca/API/CanBlackBook/submit`,
      // Mazda Drupal API
      'model-years': `${mzDrupalAPI}/api/ModelYears?lang_code=${langCode}&prov_code=${province}`,
      'model-search': `${mzDrupalAPI}/api/Model`,
      'find-dealers': `${mzDrupalAPI}/api/Dealers?lang_code=${langCode}&limit=50`,
    },
    prod: {
      // CPO APIs
      'contact-dealer': 'https://cpo.mazda.ca/API/ContactDealerservice/submit',
      'kmi': 'https://cpo.mazda.ca/API/keepmeinformed/submit',
      'request-quote': 'https://cpo.mazda.ca/API/requestaquote/submit',
      'test-drive': 'https://cpo.mazda.ca/API/bookatestdrive/submit',
      'contact': "https://cpo.mazda.ca/API/contactus/submit",
      'service-appt': "https://cpo.mazda.ca/API/BookService/Submit",
      'geolocation': "https://cpo.mazda.ca/api/geocode/json",
      'cbb': `https://cpo.mazda.ca/API/CanBlackBook/submit`,
      // Mazda Drupal API
      'model-years': `${mzDrupalAPI}/api/ModelYears?lang_code=${langCode}&prov_code=${province}`,
      'model-search': `${mzDrupalAPI}/api/Model`,
      'find-dealers': `${mzDrupalAPI}/api/Dealers?lang_code=${langCode}&limit=50`,
    }
  }

  if (endpointsList[env] && endpointsList[env][name]) {
    return endpointsList[env][name];
  } else {
    console.log('Error: End-point not found in endPoints.js')
    return null
  }

}